import CalculationGroup from './Calculation';
import { flow } from 'lodash';
import withUserInput from '../../hocs/UserInput';
import withValidation from '../../hocs/Validation';

export default flow(withUserInput, withValidation)(CalculationGroup);



// WEBPACK FOOTER //
// ../core/src/components/Calculation/index.js